import React, { Component } from 'react'

export default class Services extends Component {
  render() {
    return (
      <section className='service-block' id='services'>
        <div className="service odd">
            <h2>Group Training</h2>
            <p>Combining customization and socialization in small groups.</p>
        </div>
        <div className="service even">
            <h2>SAQ Training <span className='sm-title'>(Speed, Agility & Quickness)</span></h2>
            <p>SAQ training allows clients to enhance their ability to accelerate, decelerate and dynamically stabilize their entire body in all planes of motion (running, cutting and changing direction).</p>
        </div>
        <div className="service odd">
            <h2>Personal Training</h2>
            <p>A one-on-one experience where I will design a training program to meet your specific needs and fitness goals, using a systematic a progressive approach in the form of periodization.</p>
        </div>
      </section>
    )
  }
}
